import { otherRouter, appRouter, weixiuRouter, cusRouter } from '@/router/router'
import $data from '../../utils/data'
import _ from 'underscore'
import Cookies from 'js-cookie'
import Vue from 'vue'

function _doRules(arr) {
  const rules = $data.get('auth', 'userAuths')
  // console.log(arr, rules, 1111111);

  const arr_temp = []
  const tt = _.compact(arr)
  for (let i = 0; i < tt.length; i++) {
    let item = tt[i]
    // 设置标题
    item.meta = item.meta || {}
    item.meta.title = item.meta.title || item.title || ''
    // 判断子路由
    if (item.children && item.children.length > 0) {
      item.children = _doRules(item.children)
    }
    // 判断自身
    if (true && item.auth && _.findIndex(rules, { url: item.auth }) < 0) {
      // 拒绝， 去除路由
      // console.log(item.auth, -1)
    } else {
      // 添加
      // console.log(item, 11111111);

      arr_temp.push(item)
    }
  }
  return arr_temp
}
const app = {
  state: {
    cachePage: [],
    lang: '',
    isFullScreen: false,
    openedSubmenuArr: [], // 要展开的菜单数组
    menuTheme: 'light', // 主题
    themeColor: '',
    pageOpenedList: [
      {
        title: '首页',
        path: '',
        name: 'index_index',
      },
    ],
    currentPageName: '',
    currentPath: [
      {
        title: '首页',
        path: '',
        name: 'index_index',
      },
    ], // 面包屑数组
    menuList: [],
    routers: [otherRouter, ...appRouter, ...weixiuRouter, ...cusRouter],
    tagsList: [...otherRouter.children],
    messageCount: 0,
    dontCache: ['text-editor', 'artical-publish'], // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
    cardLoading: false, // 右边card的加载loading
    tablePage: {}, // 列表表格当前页面，用于返回时调用
    shopId: '', // 当前小区id
    shopName: '', // 当前小区name
    menuName: "",
  },
  mutations: {
    // setTagsList (state, list) {
    //     state.tagsList.push(...list);
    // },
    updateMenuName(state, name) {
      state.menuName = name;
    },
    updateMenulist(state) {
      let accessCode = parseInt(Cookies.get('access'))
      let menuList = []
      let makeMain = window.localStorage.getItem("mainType")
      let isAuths = $utils.data.get("auth", "isAuths");
      if(!isAuths){
        $utils.url.push('/index')
      }
      let tempRouter = appRouter
      // console.log(tempRouter, '----------------');

      if (makeMain == "2") {
        tempRouter = weixiuRouter
      } else if (makeMain == "3") {
        tempRouter = cusRouter
      }
      tempRouter.forEach((item, index) => {
        // console.log(item);
        if (isAuths == item.isId) {
          if (item.show === undefined || item.show === true) {
            if (item.children.length === 1) {
              if (item.show === undefined || item.show === true) {
                menuList.push(item)
              }
            } else {
              let len = menuList.push(item)
              let childrenArr = []
              childrenArr = item.children.filter((child) => {
                if (child.show === undefined || child.show === true) {
                  return child
                }
              })
              if (childrenArr === undefined || childrenArr.length === 0) {
                menuList.splice(len - 1, 1)
              } else {
                let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]))
                handledItem.children = childrenArr
                menuList.splice(len - 1, 1, handledItem)
              }
            }
          }
        }
      }
      )
      state.menuList = menuList
    },
    changeMenuTheme(state, theme) {
      state.menuTheme = theme
    },
    changeMainTheme(state, mainTheme) {
      state.themeColor = mainTheme
    },
    addOpenSubmenu(state, name) {
      let hasThisName = false
      let isEmpty = false
      if (name.length === 0) {
        isEmpty = true
      }
      if (state.openedSubmenuArr.indexOf(name) > -1) {
        hasThisName = true
      }
      if (!hasThisName && !isEmpty) {
        state.openedSubmenuArr.push(name)
      }
    },
    setCurrentPath(state, pathArr) {
      state.currentPath = pathArr
    },
    setCurrentPageName(state, name) {
      state.currentPageName = name
    },
    switchLang(state, lang) {
      state.lang = lang
      Vue.config.lang = lang
    },
    setMessageCount(state, count) {
      state.messageCount = count
    },
    // 切换右边card的加载loading
    setCardLoading(state, statues) {
      state.cardLoading = statues
    },
    // 设置当前表格页码
    setTablePage(state, tpage) {
      console.log(tpage)
      state.tablePage[tpage.name] = tpage.page
    },
    // 设置当前小区
    setShop(state, { shopId, shopName }) {
      // console.log('setShop', shopId, shopName)
      state.shopId = shopId
      state.shopName = shopName
    },
  },
}

export default app
